'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@/comps/primitives/button';
import { cn } from '@/utils/shad';
import { ArrowRight } from 'lucide-react';
type CreateProgramButtonProps = {
  onClick: () => void;
  size?: 'default' | 'compact' | 'xs';
  className?: string;
};
export function CreateProgramButton(t0) {
  const $ = _c(8);
  const {
    onClick,
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const isXs = size === "xs";
  const compact = size === "compact" || isXs;
  const t2 = compact ? "sm" : "default";
  const t3 = isXs && "h-6 px-2 text-[10px] font-medium";
  let t4;
  if ($[0] !== className || $[1] !== t3) {
    t4 = cn("shrink-0 gap-1", t3, className);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = isXs ? 9 : compact ? 10 : 12;
  let t6;
  if ($[3] !== onClick || $[4] !== t2 || $[5] !== t4 || $[6] !== t5) {
    t6 = <Button type="button" variant="outline" size={t2} className={t4} onClick={onClick} AppendIcon={ArrowRight} iconSize={t5}>Create program</Button>;
    $[3] = onClick;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}